export default __webpack_public_path__ + "static/media/business-unit-outline-16px.29546a33.svg";